import { render } from "./AssistantAdminCreator.vue?vue&type=template&id=1941d0ca"
import script from "./AssistantAdminCreator.vue?vue&type=script&lang=js"
export * from "./AssistantAdminCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__